const state = () => ({
    organisations: { options: [], label: '' },
    subjects: {options: [], label: ''},
    customers: {options: [], label: ''},
    selectedOrganisations: '',
    selectedSubjects: '',
    selectedCustomers: '',    
});

const getters = {};

const actions = {};

const mutations = {
    setOrganisationFilters(state, val) {
        state.organisations = val;
    },

    setSubjectFilters(state, val) {
        state.subjects = val;
    },

    setCustomerFilters(state, val) {        
        state.customers = val;
    },

    updateSelectedOrganisations(state, val) {
        state.selectedOrganisations = '';

        for (let i = 0; i < val.length; i++) {
            if (i != val.length - 1) state.selectedOrganisations += val[i] + ',';
            else state.selectedOrganisations += val[i];
        }                
    },

    updateSelectedSubjects(state, val) {
        state.selectedSubjects = val;
        // for (let i = 0; i < val.length; i++) {
        //     if (i != val.length - 1) state.selectedSubjects += val[i] + ',';
        //     else state.selectedSubjects += val[i];
        // }               
    },

    updateSelectedCustomers(state, val) {
        state.selectedCustomers = '';

        for (let i = 0; i < val.length; i++) {
            if (i != val.length - 1) state.selectedCustomers += val[i] + ',';
            else state.selectedCustomers += val[i];
        }               
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
